<template>
	<router-view />
</template>

<script>
	export default {
		name: 'DefaultLayout'
	}
</script>

<style>
</style>